import { useEffect, useState } from "react";
import { Eye, ArrowLeft } from "lucide-react";

const remaining = (iso) => Math.max(0, Math.round((new Date(iso).getTime() - Date.now()) / 60000));

/** Shown at the top of the agent portal while an admin is viewing/acting as an agent. */
export default function ViewAsBanner({ user, onExit }) {
  const imp = user?.impersonation;
  const [mins, setMins] = useState(() => (imp ? remaining(imp.expires_at) : 0));
  useEffect(() => {
    if (!imp) return;
    const t = setInterval(() => setMins(remaining(imp.expires_at)), 30000);
    return () => clearInterval(t);
  }, [imp]);
  if (!imp) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900" data-testid="view-as-banner">
      <span className="inline-flex items-center gap-1.5 rounded-md bg-amber-500 px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wider text-white"><Eye className="h-3 w-3" /> View as agent</span>
      <span>
        You're seeing the portal as <b data-testid="view-as-agent-name">{user.name}</b>. Anything you change here is saved to {user.name.split(" ")[0]}'s recruits and logged as <b>{imp.admin_name}</b>.
      </span>
      <span className="font-mono-num text-xs text-amber-700" data-testid="view-as-expiry">Session ends in {mins} min</span>
      <button onClick={onExit} data-testid="view-as-exit" className="ml-auto inline-flex min-h-[36px] items-center gap-1.5 rounded-lg bg-[#0b1528] px-3 py-1.5 text-xs font-bold text-white hover:bg-slate-800 transition-colors">
        <ArrowLeft className="h-3.5 w-3.5" /> Back to admin
      </button>
    </div>
  );
}
